import {
  IGetInterviewDetailsAction,
  IGetInterviewMetaAction,
} from "@/types/interview.types";
import {
  GET_INTERVIEW_DETAILS,
  GET_INTERVIEW_META,
  SET_STARTED_TIME,
  GET_SERVER_TIME,
} from "@/constants/ActionTypes";

export const getInterviewMeta = (
  accessCode: string,
): IGetInterviewMetaAction => ({
  type: GET_INTERVIEW_META,
  payload: {
    accessCode,
  },
});

export const setStartedTime = (startTime: string) => ({
  type: SET_STARTED_TIME,
  payload: {
    started_at: startTime,
  },
});

export const getServerTimeAction = () => ({
  type: GET_SERVER_TIME,
});

export const getInterviewDetailsAction = (
  interviewSlug: string,
): IGetInterviewDetailsAction => ({
  type: GET_INTERVIEW_DETAILS,
  payload: {
    interviewSlug,
  },
});
